var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewDetail = function SvgViewDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 14.5V4H5v16h8.5m5.5-5.5L13.5 20m5.5-5.5h-5.5V20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8 8h8M8 12h8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M8 15.25a.75.75 0 0 0 0 1.5zm3 0H8v1.5h3z"
  })));
};
export { SvgViewDetail as ReactComponent };
export default __webpack_public_path__ + "d73bef5dae3f7310afb94bdd4f7ca243.svg";